import { render, staticRenderFns } from "./widgetAccountInput.vue?vue&type=template&id=dab1a1aa&scoped=true"
import script from "./widgetAccountInput.vue?vue&type=script&lang=js"
export * from "./widgetAccountInput.vue?vue&type=script&lang=js"
import style0 from "./widgetAccountInput.vue?vue&type=style&index=0&id=dab1a1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab1a1aa",
  null
  
)

export default component.exports